import { EUserRole } from 'src/types/user'

export const ERedirectReason = {
  VALIDATE_EMAIL_INIT_PASSWORD: 'VALIDATE_EMAIL_INIT_PASSWORD',
  VALIDATE_EMAIL: 'VALIDATE_EMAIL',
  RESET_PASSWORD: 'RESET_PASSWORD',
} as const

export type ERedirectReason = (typeof ERedirectReason)[keyof typeof ERedirectReason]

export const REDIRECT_REASON_LIST = Object.values(ERedirectReason)

export type TRedirectReason = (typeof REDIRECT_REASON_LIST)[number]

export const API_ERROR_MESSAGE: Record<TRedirectReason | 'REQUEST_PIN', string> = {
  VALIDATE_EMAIL_INIT_PASSWORD: 'User email verification and reset password required',
  VALIDATE_EMAIL: 'User email verification required',
  RESET_PASSWORD:
    'Vous avez reçu un code de réinitialisation il y a moins de deux heures. Veuillez entrer ce code',
  REQUEST_PIN:
    'Vous avez reçu un code de réinitialisation il y a moins de deux heures. Veuillez entrer ce code',
}

export const EFormField = {
  CONFIRM_PASSWORD: 'confirmPassword',
  NEW_PASSWORD: 'newPassword',
  OLD_PASSWORD: 'oldPassword',
  PASSWORD: 'password',
  EMAIL: 'email',
  PIN: 'pin',
} as const

export type EFormField = (typeof EFormField)[keyof typeof EFormField]

export const FORM_FIELDS = Object.values(EFormField)

export type TFormValue = Partial<Record<EFormField, string>>

export type TLogin = {
  email: string
  password: string
}

export type TRequestPin = {
  email: string
}

export type TVaidateEmailInitPassword = {
  email: string
  pin: string
  password: string
  newPassword: string
}

export type TValidateEmail = {
  email: string
  pin: string
  password: string
}

export type TResetPassword = {
  email: string
  pin: string
  password: string
}

export type TRegister = {
  role: EUserRole
  access_token: string
}
